import { IgetTransactionsAPIBody } from 'api/endpoints/transactions/transactions.response.interface';
import { ITableColumnsSelectOrderState } from 'interfaces/tables.interface';
import { IInitialTransactionsState } from 'interfaces/transactions.interface';

const deliveryNotesBody: IgetTransactionsAPIBody = {
  index: 0,
  limit: 10,
  filter: {
    'Client ID': {
      value: '',
      operator: '=',
    },
  },
};

const billsBody: IgetTransactionsAPIBody = JSON.parse(JSON.stringify(deliveryNotesBody));

const ordersBody: IgetTransactionsAPIBody = JSON.parse(JSON.stringify(deliveryNotesBody));

export const initialTransactionsColumnsOrder: Record<
  string,
  ITableColumnsSelectOrderState
> = {};

const initialTransactionsState: IInitialTransactionsState = {
  // Delivery Notes /////////////////////////////////////////////
  deliveryNotesBodyFetch: deliveryNotesBody,
  getDeliveryNotesItems: () => Promise.resolve(false),
  deliveryNotesItems: { count: 0, total: 0, data: [] },
  isLoadingDeliveryNotesItems: false,
  searchOnDeliveryNotesItems: () => Promise.resolve(false),
  handleDeliveryNotesPagination: () => Promise.resolve(false),
  deliveryNotesColumnsOrder: initialTransactionsColumnsOrder,
  deliveryNotesMoveColumnsOrder: () => {},
  deliveryNotesCheckColumn: () => {},
  // Bills //////////////////////////////////////////////////////
  billsBodyFetch: billsBody,
  getBillsItems: () => Promise.resolve(false),
  billsItems: { count: 0, total: 0, data: [] },
  isLoadingBillsItems: false,
  searchOnBillsItems: () => Promise.resolve(false),
  handleBillsPagination: () => Promise.resolve(false),
  billsColumnsOrder: initialTransactionsColumnsOrder,
  billsMoveColumnsOrder: () => {},
  billsCheckColumn: () => {},
  // Orders //////////////////////////////////////////////////////
  ordersBodyFetch: ordersBody,
  getOrdersItems: () => Promise.resolve(false),
  ordersItems: { count: 0, total: 0, data: [] },
  isLoadingOrdersItems: false,
  searchOnOrdersItems: () => Promise.resolve(false),
  handleOrdersPagination: () => Promise.resolve(false),
  ordersColumnsOrder: initialTransactionsColumnsOrder,
  ordersMoveColumnsOrder: () => {},
  ordersCheckColumn: () => {},
};

export default initialTransactionsState;
